import Main from '../../assets/js/modules/Main'
import Utils from '../../assets/js/modules/Utils'
import 'container-query-polyfill'

const modules = {
	HxpReactFactory: async () =>
		import(
			/* webpackChunkName: 'HxpReactFactory' */ `./factories/HxpReactFactory`
		),
}

let hxpInstance = new Main(modules, Utils)
hxpInstance.init()
